<template>
	<div>
		<div class="d-flex justify-space-between">
			<h2 class="mb-4">Analytics</h2>
		</div>
		<div>
			<v-tabs v-model="tab" @change="selectTab" background-color="#003366" grow dark> 
                <v-tab href="#training" class="activetab">Training Analytics
                <v-select class="optionContext" background-color="transparent" color="#FFF" style="max-width: 70px;"
                 @change="selectBusinessName" v-model="BusinessNameSelected" :items="optionsBN" item-text="name" item-value="id"></v-select>
			</v-tab>
			<v-tab href="#engagement" class="activetab">Engagement Analytics
                <v-select class="optionContext" background-color="transparent" color="#FFF" style="max-width: 70px;"
                 @change="selectExperience" v-model="experienceSelected" :items="options" item-text="name" item-value="id"></v-select>
            </v-tab>
			</v-tabs>
			<v-tabs-items v-model="tab" class="admintabs">
				<v-tab-item value="training">
					<dashboard-profile :option="optionSelected" :guid="tenantGUID" :adminExperienceId="experienceSelected" :businessnameId="BusinessNameSelected"/>
				</v-tab-item>
				<v-tab-item value="engagement">
					<dashboard-profile :option="optionSelected" :guid="tenantGUID" :adminExperienceId="experienceSelected" :businessnameId="BusinessNameSelected"/>
				</v-tab-item>
			</v-tabs-items>
		</div>
	</div>
</template>

<style>
    .optionContext.v-text-field>.v-input__control>.v-input__slot:before {
        border-style: none;
    }
    .optionContext.v-text-field>.v-input__control>.v-input__slot:after {
        border-style: none;
    }

    .optionContext .v-select__selection,
    .optionContext .v-select__selection--comma,
    .optionContext .v-select.v-text-field input {
        color: transparent !important;
    }
    .activetab.v-tab:active {
        background-color: #3D648B
    }

    .admintabs.theme--light.v-tabs-items {
        background-color: white;
    }
</style>

<script>
import axios from "axios";
import DashboardProfile from "../experience/profiletab/dashboard";

export default {
    components: { DashboardProfile },
	data() {
		return {
            tab: 1,
            tenantGUID: "",
			optionSelected: 0,
            experienceSelected: 0,
            BusinessNameSelected: 0,
			options: [],
			optionsBN: [],

			selected : {
                experience: 0,
                booth: 0,
                video: 0
            },
            expOption: [
                { text : "Overall Stat Summary of Attendees", value : 0},
                { text : "User Login Report", value : 1},
                { text : "User Added Item To Briefcase", value : 2},
                { text : "User Removed Item From Briefcase", value : 3},
                { text : "User Leaderboard", value : 4},
            ],
            boothOption: [
                { text : "Number Of Booth Visitor", value : 0},
                { text : "Overall Booth Summary", value : 1},
                { text : "Booth Document And Video Viewed", value : 2},
                { text : "Booth Banner Clicked", value : 3},
                { text : "Booth Content Links Clicked", value : 4},
            ],
            videoOption: [
                { text : "Presentation Video Viewed", value : 0},
                { text : "Live Presentation Unique Viewed", value : 1},
                { text : "Room Banner Visited", value : 2},
            ],

            expKey: [],
            expValue: [],

            boothKey: [],
            boothValue: [],

            videoKey: [],
            videoValue: [],

            chatKey: [],
            chatValue: [],

            chatData: {
                labels: [],
                datasets: [{ 
                    data: [], 
                    backgroundColor: ['#6CE5E8', '#41B8D5', '#2D8BBA', '#2F5F98', '#18304D'],
                    borderColor: ['#6CE5E8', '#41B8D5', '#2D8BBA', '#2F5F98', '#18304D'],
                    borderWidth: 2,
                    hoverOffset: 10
                }]
            },
            boothData: {
                labels: [],
                datasets: [{ 
                    data: [], 
                    backgroundColor: ['#6CE5E8', '#41B8D5', '#2D8BBA', '#2F5F98', '#18304D'],
                    borderColor: ['#6CE5E8', '#41B8D5', '#2D8BBA', '#2F5F98', '#18304D'],
                    borderWidth: 2,
                    hoverOffset: 10
                }]
            },
            experienceData: {
                labels: [],
                datasets: [{ 
                    data: [], 
                    backgroundColor: ['#6CE5E8', '#41B8D5', '#2D8BBA', '#2F5F98'],
                    borderColor: ['#6CE5E8', '#41B8D5', '#2D8BBA', '#2F5F98'],
                    borderWidth: 2,
                    hoverOffset: 0
                }]
            },
            videoData: {
                labels: [],
                datasets: [{ 
                    backgroundColor: '#6CE5E8',
                    borderColor: ['#6CE5E8'],
                    data: [], 
                    fill: true
                }]
            },
            chartDoughnutOptions: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'right',
                        align: 'center',
                        labels : {
                            boxWidth : 30,
                            boxHeight : 30,
                            padding: 20,
                            font : {
                                size: 15
                            },
                            textAlign: 'center'

                        }
                    }
                }
            },
            chartBarOptions: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                    x: {
                        ticks: {
                            precision: 0,
                            display: true,
                            font: {
                                size: 15
                            }
                        },
                        display: true,
                        grid: {
                            display: false
                        }
                    },
                    y: {
                        ticks: {
                            precision: 0,
                            display: true,
                            font: {
                                size: 15
                            }
                        },
                        grid: {
                            display: false
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    }
                }
            },
            chartLineOptions: {
                layout: {
                    padding: 0
                },
                elements: {
                    point: {
                        radius: 0,
                        borderWidth: 0
                    }
                },
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                    x: {
                        ticks: {
                            precision: 0,
                            display: true,
                            font: {
                                size: 15
                            }
                        },
                        display: true,
                        grid: {
                            display: false
                        }
                    },
                    y: {
                        ticks: {
                            precision: 0,
                            display: true,
                            beginAtZero: true,
                            font: {
                                size: 15
                            }
                        },
                        suggestedMin: 0,
                        grid: {
                            display: true,
                        }
                    }
                },
                interaction: {
                    mode: 'index',
                    intersect: false
                },
                plugins: {
                    legend: {
                        display: false
                    }
                }
            },
		};
	},
	mounted: function () {
        this.tab = "engagement"
		this.getExperienceList();
        this.getBusinessNameList();
	},
	methods: {
        selectExperience(e) {
            this.experienceSelected = e;
        },
        selectBusinessName(e) {
            this.BusinessNameSelected = e;
        },
        selectTab(e) {
            this.optionSelected = e === "engagement" ? 0 : 1
        },
		getExperienceList() {
			axios.get("/system/experience/list")
            .then(response => {

				this.options = response.data
				this.experienceSelected = this.options[0].id

                this.setGUID()
            })
            .catch(() => {});
		},
        getBusinessNameList() {
			axios.get("/system/businessname/list1").then(response => { 
                this.optionsBN = response.data 
				this.BusinessNameSelected = this.optionsBN[0].id
            }).catch(() => {});
		},
		setGUID() {
            axios.get("/system/vTraining/tenant/guid?id=" + this.$store.state.principal.tenantId).then((res) => {
                this.tenantGUID = res.data;
			});
		},
	}
};
</script>
